const Theme = {
  logo_image_url: 'epeak.png',

  button_color: '#d03808',
  button_radius: 2,

  text_font: `'Open Sans', sans-serif`,
  title_font: `'Open Sans', sans-serif`,
}

export default Theme
